// components/OttoFirmwareFlash.tsx
// Otto 기기 화면의 [펌웨어 다운로드] 버튼: 누르면 설치 패널이 열린다. (설치는 FirmwareFlasher 가 한다)
import React, { useState } from 'react';
import FirmwareFlasher from './FirmwareFlasher';

const RAW = 'https://raw.githubusercontent.com/kdi6033/download/main/';
// 새 위치(맨 위) 먼저, 없으면 옛 위치(otto 폴더)
const OTTO_URLS = [RAW + 'otto.ino.merged.bin', RAW + 'otto/otto.ino.merged.bin'];

const OttoFirmwareFlash: React.FC = () => {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ textAlign: 'right' }}>
      <button type="button" className="action-btn btn-primary" onClick={() => setOpen((o) => !o)}>
        ⬇ 펌웨어 다운로드
      </button>
      {open && (
        <div style={{ marginTop: '10px' }}>
          <FirmwareFlasher title="Otto" fileUrls={OTTO_URLS} />
        </div>
      )}
    </div>
  );
};

export default OttoFirmwareFlash;
